import functions from "./functions.js";
import tplLoader from "./tpl-loader.js";

$(function () {

    const $form = $('.booking-form');
    const form = $form[0];

    if (!form) {
        return;
    }

    const booking = {
        $form: null,
        totalAmount: null,
        totalAmountConverted: null,
        $payment: null,
        $calculation: null,
        calc: [],
        persons: null,

        init() {
            booking.$form = $(".personal-info-form");
            booking.$calculation = $(".table-calculation");
            booking.$payment = $(".payment-details");
            booking.params = {};


            booking.calcTableEvents();


            if (booking.$payment.length) {
                booking.params.paymentType = 'creditCard';
                booking.$payment.find('input[name="paymentType"]').change(function (e) {
                    booking.params.paymentType = booking.$payment.find('input[name="paymentType"]:checked').val();
                });
            }

            
            $('input[name="travel_insurance"]').on('change', function(e) {
                $('input[name="travel_insurance"]').not(this).prop({'checked': false});

                booking.calculate($('input[name="travel_insurance"]').not(this));
                booking.calculate($(this));
            });

            if ($('.equipment-rent').length)
            {
                $('input[name="equipment"]').on('change', function(e) {
                    if ($(e.target).val())
                    {
                        $('.equipment-rent').removeClass('pe-none opacity-50');
                        $('input[name="height"], input[name="weight"], input[name="foot_size"]').val('').prop('required', true);
                    }
                    else 
                    {
                        $('.equipment-rent').addClass('pe-none opacity-50');
                        $('input[name="height"], input[name="weight"], input[name="foot_size"]').val('').prop('required', false);
                    }
                });

                let origVal = 0;
                $('input[name="equipment[]"]').on('change', function(e) {
                    
                    let hasAtLeastOneValue = $('input[name="equipment[]"]:checked').length;

                    if (hasAtLeastOneValue)
                    {
                        $('.equipment-rent').removeClass('pe-none opacity-50');
                        $('input[name="height"], input[name="weight"], input[name="foot_size"]').prop('required', true);
                        $('input[name="rent-days"]').prop('required', true);
                    }
                    else 
                    {
                        $('.equipment-rent').addClass('pe-none opacity-50');
                        $('input[name="height"], input[name="weight"], input[name="foot_size"], input[name="rent-days"]').val('').prop('required', false);
                        $('input[name="rent-days"]').prop('required', false).prop('checked', false);

                    }
                });

                $('.sc-ss[type="checkbox"]').on('change', function() {
                    $('.sc-ss[type="checkbox"]').not(this).prop('checked', false);
                    });
            }

            $('.payment-type-wrapper').on('click', function (e) {
                let labelTag = $(e.target).closest('label').attr('for');
                let $labels = $(this).find('label');
                $labels.each((index, item) => {
                    let $elem = $(item);
                    if ($elem.attr('for') == labelTag)
                    {
                        $elem.removeClass('border-white').addClass('border-primary');
                    }
                    else
                    {
                        $elem.removeClass('border-primary').addClass('border-white');
                    }
                    let $transferInfo = $elem.find('.bank-transfer-info');
                    if($transferInfo.length) $transferInfo.toggleClass('active', $elem.attr('for') == labelTag)
                })
            });

            $('.booking-calc-form').on('change', function(e) {
                let params = functions.getFormData($('.booking-calc-form'));
                $('#calculation-wrapper').prepend(tplLoader).scrollTop(0);
                booking.splitDates(params);
                params['language']  = functions.getLang();
                params['addAllOptionals'] = 1;
                $.get('/services/bookingFormRecalculate', params).then(response => {

                    setTimeout(() => {
                        $('#calculation-wrapper').find('.list-loader').remove();
                        response = JSON.parse(response);
                        booking.calc = [];
                        $('#calculation-wrapper').html(response.html);
                        booking.calcTableEvents();
                    }, 500);
                });
            });


            var requiredCheckboxes = $('#transportationSupplement :checkbox[required]');
            requiredCheckboxes.change(function(){
                if ($(this).is(':checked')) {
                    requiredCheckboxes.not(this).prop('checked', false).trigger('change');
                }

                if(requiredCheckboxes.is(':checked')) {
                    requiredCheckboxes.removeAttr('required');
                } else {
                    requiredCheckboxes.attr('required', 'required');
                }
            });

            
            booking.$form.on('submit', e => {
                // console.log(functions.getFormData(booking.$form));

                let $paymentTypeForm = $('#transportationSupplement');
                if ( $paymentTypeForm.length && ! $paymentTypeForm[0].checkValidity()) {
                    
                    var tmpSubmit = document.createElement('button');
                    $paymentTypeForm[0].appendChild(tmpSubmit);
                    tmpSubmit.click();
                    $paymentTypeForm[0].removeChild(tmpSubmit);

                    e.preventDefault();
                    return;
                }

               booking.submit();
            });

        },
        submit() {


            $.each(booking.calc, function(key, item) {
                if ( ! item.inCalc) {
                    delete booking.calc[key];
                } else if (item.itemDefinitionId.categoryId.key == 'baseRate') {
                    booking.calc[key].guestsData = [];
                    booking.calc[key].placeFromId = $("select[name='placeFromId']").val();
                    booking.calc[key].guestsData[0] = {
                        firstName : $("input[name='firstName']").val(),
                        lastName : $("input[name='lastName']").val(),
                        birthDate : $("*[name='birthDateYear']").val() + '-' + $("*[name='birthDateMonth']").val() + '-' + $("*[name='birthDateDay']").val()
                    };
                }
            });


            booking.params.status = $("input[name='status']").val();
            booking.params.paymentModelId = $("input[name='paymentModelId']").val();
            booking.params.departureCity = $("select[name='placeFromId'] option:selected").text();
            booking.params.birthDate = $("*[name='birthDateYear']").val() + '-' + $("*[name='birthDateMonth']").val() + '-' + $("*[name='birthDateDay']").val();
            booking.params.calc = JSON.stringify(booking.calc);
            booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);
            $.each(booking.params, function (key, param) {
                $('<input>').attr({
                    type: 'hidden',
                    name: key,
                    value: param
                }).appendTo(booking.$form);
            });
        },
        calculate($elem) {
            let $row = $elem.closest('.calc-item');

            let $checkbox = $row.find('input[type="checkbox"]');
            let checked = $checkbox.is(':checked') ? 1 : 0;
            let id = $checkbox.attr('id');

            let $quantity = $row.find('select.quantity');
            let quantity = null;

            if ($quantity.length) {
                quantity = +$quantity.val();
            }

            $.each(booking.calc, function (key, calc) {
                if (calc.id == id) {

                    if (quantity == null) {
                        quantity = booking.calc[key].quantity;
                    }

                    booking.calc[key].inCalc = checked;
                    booking.calc[key].quantity = (quantity || 1);
                    booking.calc[key].total = booking.itemTotal(booking.calc[key]);

                    $row.find('.item-total-amount').html(functions.formatMoney(booking.calc[key].total, 2, ',', '.'));
                }
            });

            booking.total();
        },
        itemTotal(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek']) > -1) {
                    itemTotal = +item.quantity * +item.price;
                } else {
                    itemTotal = +item.price;
                }
            } else {
                itemTotal = +item.quantity * +item.price;
            }

            return itemTotal;
        },
        itemTotalConverted(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek']) > -1) {
                    itemTotal = +item.quantity * +item.priceConverted;
                } else {
                    itemTotal = +item.priceConverted;
                }
            } else {
                itemTotal = +item.quantity * +item.priceConverted;
            }

            return itemTotal;
        },
        total() {
            booking.totalAmount = 0.00;
            booking.totalAmountConverted = 0.00;

            $.each(booking.calc, function (key, calc) {
                if (!calc.onSpot && calc.inCalc) {
                    booking.totalAmount += booking.itemTotal(calc);
                    booking.totalAmountConverted += booking.itemTotalConverted(calc);
                }
            });

            $('.total-amount').html(functions.formatMoney(booking.totalAmount, 2, ',', '.'));
            $('.total-converted').html(functions.formatMoney(booking.totalAmount * 7.53450, 2, ',', '.'));

            const advancePaymentPercent = $('[data-advancePaymentPercent]').attr('data-advancepaymentpercent');

            const advance = booking.totalAmount * (advancePaymentPercent / 100);
            const rest = booking.totalAmount - advance;

            booking.$calculation.find('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
            booking.$calculation.find('.rest').html(functions.formatMoney(rest, 2, ',', '.'));

            const advanceConverted = booking.totalAmountConverted * (advancePaymentPercent / 100);
            const restConverted = booking.totalAmountConverted - advanceConverted;

            booking.$calculation.find('.advance-converted').html(functions.formatMoney(advanceConverted, 2, ',', '.'));
            booking.$calculation.find('.rest-converted').html(functions.formatMoney(restConverted, 2, ',', '.'));

        },
        splitDates(params) {
            if(params.period)
            {
                let val = params.period.split(' - ');
                params.dateFrom  = val[0];
                params.dateTo    = val[1];
                params.period = null;
            }
            else
            {
                return;
            }  
        },

        calcTableEvents()
        {
            booking.$calculation.find("*[data-calc]").each(function (index) {
                let item = JSON.parse($(this).attr('data-calc'));
                item.inCalc = item.isOptional ? 0 : 1;

                if (item.itemTitle && item.itemTitle.name_hr.toLowerCase() === 'plaćanje mastercard karticom') {
                    item.quantity = +item.quantity;
                    if (item.quantity >= 5 && item.quantity < 10) {
                        item.quantity -= 1;
                    } else if (item.quantity >= 10 && item.quantity < 15) {
                        item.quantity -= 2;
                    } else if (item.quantity >= 15) {
                        item.quantity -= 3;
                    }

                    console.log(item.quantity);
                }

                booking.calc.push(item);
            });

            booking.$calculation.find('input[type="checkbox"]').change(function (e) {
                let $row = $(this).closest('.calc-item');
                let $quantity = $row.find('select.quantity');
                let value = +$quantity.val();
                let checked = $(this).is(':checked') ? 1 : 0;
                
                if (checked && !value) {
                    $quantity.prop('value', 1);
                } else if (!checked && value) {
                    $quantity.prop('value', 0);
                }

                booking.calculate($(this));
            });

            var requiredCheckboxes = $('#transportationSupplement :checkbox[required]');

            requiredCheckboxes.change(function(){
                if ($(this).is(':checked')) {
                    requiredCheckboxes.not(this).prop('checked', false).trigger('change');
                }

                if(requiredCheckboxes.is(':checked')) {
                    requiredCheckboxes.removeAttr('required');
                } else {
                    requiredCheckboxes.attr('required', 'required');
                }
            });




            booking.$calculation.find('select.quantity').change(function (e) {
                let $row = $(this).closest('tr');
                let $checkbox = $row.find('input[type="checkbox"]');
                let value = +$(this).val();

                if (value && !$checkbox.is(':checked')) {
                    $checkbox.prop('checked', true);
                } else if (!value && $checkbox.is(':checked')) {
                    $checkbox.prop('checked', false);
                }

                booking.calculate($(this));
            });

            booking.total();
        }
    }

    booking.init();
});